const footerNav = [
  { id: 1, label: '今日瓜速递', href: '#today' },
  { id: 2, label: '话题墙', href: '#topics' },
  { id: 3, label: '新鲜爆料', href: '#leaks' },
  { id: 4, label: '最新八卦', href: '#gossip' },
  { id: 5, label: '吃瓜热度榜', href: '#rank' },
];

const footerTopics = ['古装剧换角', '演唱会加场', '红毯造型', '综艺改版', '待播剧排期', '二创名场面'];

const footerRules = [
  { id: 1, icon: 'ri-shield-check-line', text: '未证实信息统一标注问号' },
  { id: 2, icon: 'ri-link', text: '每条爆料保留原始出处' },
  { id: 3, icon: 'ri-hand-heart-line', text: '讨论只聊事，不针对个人' },
  { id: 4, icon: 'ri-delete-bin-6-line', text: '可申请下架失实内容' },
];

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-primary-900 to-primary-950 text-primary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-emotion-happy-line text-xl"></i>
              </span>
              <span className="font-heading text-xl text-white">1每日吃瓜</span>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-primary-100/75">
              一个把今日瓜、新鲜爆料和最新八卦按时间整理好的地方。今天有什么新瓜，来这儿看一眼就知道。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-primary-100/80">
              <span className="flex h-3 w-3 items-center justify-center">
                <span className="block h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-dot"></span>
              </span>
              最近更新 · 今天 10:24
            </div>
          </div>

          <nav>
            <h3 className="text-sm font-bold text-white">站内分区</h3>
            <ul className="mt-4 space-y-2.5">
              {footerNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={item.href}
                    className="text-xs text-primary-100/75 transition hover:text-white"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold text-white">热门话题</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {footerTopics.map((topic) => (
                <li key={topic}>
                  <a
                    href="#topics"
                    className="inline-block whitespace-nowrap rounded-full border border-primary-400/40 px-2.5 py-1 text-xs text-primary-100/80 transition hover:border-accent-400 hover:text-white"
                  >
                    {topic}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white">吃瓜守则</h3>
            <ul className="mt-4 space-y-3">
              {footerRules.map((rule) => (
                <li key={rule.id} className="flex items-start gap-2 text-xs text-primary-100/75">
                  <i className={`${rule.icon} mt-0.5`}></i>
                  <span className="leading-relaxed">{rule.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-400/30 pt-6 text-xs text-primary-100/65 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 1每日吃瓜 · 内容为网友讨论整理，仅供参考，请理性吃瓜</p>
          <p className="flex flex-wrap items-center gap-3">
            <span>关于我们</span>
            <span>内容规范</span>
            <span>联系与反馈</span>
          </p>
        </div>
      </div>
    </footer>
  );
}